import { Box, Typography } from '@mui/material';
import { emptyIndividualText, emptyLegalText } from '../../constants';

interface IEmptuOwnersListProps {
  isIndividual?: boolean;
}

export const EmptyOwnersList = ({ isIndividual }: IEmptuOwnersListProps) => {
  return (
    <Box sx={{ p: 4 }}>
      <Typography sx={{ textAlign: 'center', color: 'gray' }}>
        {isIndividual ? emptyIndividualText : emptyLegalText}
      </Typography>
    </Box>
  );
};
